const env = "prod";

const Config = {
  prod: {
    apiEndpoint: "https://api.ginastee.com/api/manager",
    wsEndpoint: "wss://api.ginastee.com/app/7d73d67e780a94f36a34t",

    //Informações de pagamento
    payments: {
      plans: {
        YEARLY: "price_1Pz7g1Ky3lsbQzMatCbqWDs8",
        MONTHLY: "price_1Pz7fiKy3lsbQzMamPg4fcvK",
      },
      stripeKey:
        "pk_live_51OMAXaKy3lsbQzMaJIZUrCFL5rOXSYcREfOLyTaIpTPmhElGluLaDrcCUzIgoU1V0rt9ZoWcomDfxbaB4C04xXl900eZfp34Fb",
    },
  },
  home: {
    apiEndpoint: "http://10.0.0.111:8000/api/manager",
    wsEndpoint: "ws://10.0.0.111:6001/app/ginastee-app-chat",

    //Informações de pagamento
    payments: {
      plans: {
        YEARLY: "price_1PvQrsKy3lsbQzMawKMWOry5",
        MONTHLY: "price_1PvQrsKy3lsbQzMajUcg7IiZ",
      },
      stripeKey:
        "pk_test_51OMAXaKy3lsbQzMaZ6ciGPHBpEGikVNJWuYYPTh5dggMAOzhEvHIJQu9aatnuj4yHcd0mLSLZdpOVbHQQV1FW1db00LsZI3voF",
    },
  },
  backstage: {
    apiEndpoint: "https://api-test.ginastee.com/api/manager",
    wsEndpoint: "wss://api-test.ginastee.com:6001/app/ginastee-app-chat",
    
    //Informações de pagamento
    payments: {
      plans: {
        YEARLY: "price_1PvQrsKy3lsbQzMawKMWOry5",
        MONTHLY: "price_1PvQrsKy3lsbQzMajUcg7IiZ",
      },
      stripeKey:
        "pk_test_51OMAXaKy3lsbQzMaZ6ciGPHBpEGikVNJWuYYPTh5dggMAOzhEvHIJQu9aatnuj4yHcd0mLSLZdpOVbHQQV1FW1db00LsZI3voF",
    },
  },
  apiToken: getToken(),
};

function getToken() {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!token) return false;
    return token;
  } catch (e) {
    return false;
  }
}

export default Config[env];

export const token = Config.apiToken;
